/**
 *
 * Root
 *
 */

import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useQueryParams } from '@domonda/query-params';
import store from 'store';
import { customerConfigKey } from 'lib/configStoreKey';

// api
import { subscribeToToken, getToken, setToken as setAccessToken } from 'lib/api/auth';
import { getCustomerConfig } from 'lib/api/customerConfig';

// ui
import { Flex } from '@domonda/ui/Flex';

// routes
import {
  AUTHENTICATE_PAGE,
  LOGOUT_PAGE,
  DOCUMENTS_PAGE,
  UPLOAD_PAGE,
  RELEASE_PAGE,
  SETTINGS_PAGE,
  DASHBOARD_PAGE,
} from 'lib/routes';
import {
  LoginPage,
  LogoutPage,
  DocumentsPage,
  UploadPage,
  ReleasePage,
  SettingsPage,
  FourOhFourPage,
  DashboardPage,
} from 'core/pages';

import { DemoDocumentsDetailPage } from 'core/pages/DocumentsPage/DemoDocumentsDetailPage';

// parts
import { AppBar } from '../AppBar';

// decorate
import { decorate, Decorate } from './decorate';

interface RootQueryParams {
  at: string | null;
}

// we memo the content because the Root component will update on every location change
const RootContent = React.memo<Decorate>(({ classes }) => (
  <Flex container direction="column">
    <Flex item component="header" className={classes.header}>
      <AppBar />
    </Flex>

    <Flex item container component="main" flex={1} className={classes.content}>
      <Switch>
        <Redirect exact={true} from="/" to="/trial" />
        <Route path="/trial" component={DemoDocumentsDetailPage} />
        <Route component={FourOhFourPage} />
      </Switch>
    </Flex>
  </Flex>
));

if (process.env.NODE_ENV !== 'production') {
  RootContent.displayName = 'RootContent';
}

const Root: React.FC<Decorate> = (props) => {
  const { classes } = props;

/*
  const [token, setToken] = useState(getToken());

  useEffect(() => {
    const unsubscribe = subscribeToToken(setToken);
    return unsubscribe;
  }, []);

  const [{ at: accessToken }] = useQueryParams<RootQueryParams>(
    { at: { type: 'string', defaultValue: null } },
    { onPathname: AUTHENTICATE_PAGE, disableReplace: true },
  );

  useEffect(() => {
    if (accessToken) {
      setAccessToken(accessToken);
    }
  }, [accessToken]);
  useEffect(() => {
    async function getConfig() {
      if (accessToken) {
        const response = await getCustomerConfig();
        if (response.State === 0) store.set(customerConfigKey, response);
      }
    }
    getConfig();
  }, [accessToken]);

  if (!token) {
    return <LoginPage />;
  }

  // clean the parameters
  if (token && accessToken) {
    return <Redirect to="/" />;
  }
*/

  return <RootContent classes={classes} />;
};

const StyledRoot = decorate(Root);
export { StyledRoot as Root };
